import React from "react";
import { FiCheckCircle, FiHome } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const FailedTutorPayment = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Get payment details from URL parameters
  const paymentDetails = {
    amount: queryParams.get("amt") || "26.00",
    transactionId: queryParams.get("ref") || "N/A",
    orderId: queryParams.get("order-id") || "N/A",
    status: queryParams.get("status") || "success"
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center p-5">
              {/* Success Icon */}
              <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4" 
                  style={{ width: '100px', height: '100px' }}>
                <FiCheckCircle className="text-success" size={48} />
              </div>
              
              {/* Thank You Message */}
              <h2 className="mb-3 fw-bold">Registration Payment Failed!</h2>
              <p className="lead text-muted mb-4">
                Your payment for tutor registration failed.
                Your account is partially activated.
              </p>
              <p>Try again to get your account fully activated.</p>
              
              {/* Payment Details */}
              <div className="bg-light p-4 rounded-3 mb-4">
                <div className="row">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <p className="mb-1 text-muted">Payment Amount</p>
                    <p className="fw-bold text-success">GHS {paymentDetails.amount}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1 text-muted">Transaction ID</p>
                    <p className="fw-bold"><small>{paymentDetails.transactionId}</small></p>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12">
                    <p className="mb-1 text-muted">Order Reference</p>
                    <p className="fw-bold"><small>{paymentDetails.orderId}</small></p>
                  </div>
                </div>
              </div>
              
              
              {/* Action Buttons */}
              <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
                <Link to="/" className="btn btn-outline-secondary px-4 py-2">
                  <FiHome className="me-2" />
                  Return Home
                </Link>
                <Link to="/tutor/login" className="btn btn-primary px-4 py-2">
                  Go to Tutor Login
                </Link>
              </div>
              
              {/* Additional Info */}
              <div className="mt-4 small text-muted">
                <p>
                  Your tutor account will be fully activated within 24 hours.
                  You can start creating your profile once you log in.
                </p>
                <p className="mb-0">
                  Need help? Contact us at <a href="mailto:eddcodes17@gmail.com">eddcodes17@gmail.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FailedTutorPayment;